export default __webpack_public_path__ + "static/gone-hybrid-logo-a844eb13d56622549c0c801e661a7310.svg";